import { useRouter } from 'next/router';

import { TranslationService } from '@/utils/services/TranslationService';

import { ANALYZE_IMPRESSIONS, ANALYZE_REACH_IMPRESSIONS } from '@/lib/routes/privateRoutes';

import LoaderPage from '@/components/base/Loader/LoaderPage';
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';

const Page = () => {
    const router = useRouter();

    router.push(ANALYZE_REACH_IMPRESSIONS);
    return <LoaderPage />;
};

const Impressions = () => (
    <WrapperSwitchLayout>
        <Page />
    </WrapperSwitchLayout>
);

export const getStaticProps =
    TranslationService.getTranslationMessagesFromRoute(ANALYZE_IMPRESSIONS);

export default Impressions;
